module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Export Details")]), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.goRolloverCont
    }
  }, [_vm._v("Rollover Container")]), _vm._v(" "), (_vm.FFExport.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-2",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('FF_SEA_EXPORT', 'Export As Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.gotoPendency()
      }
    }
  }, [_vm._v("\n            Show Pendency List\n          ")]), _vm._v(" "), (_vm.$sessionsStorage.get('employeeName') == 'RIMPLE KATHURIA') ? _c('b-button', {
    staticClass: "pull-right mr-2 sline-reminder-btn",
    attrs: {
      "disabled": _vm.isSendingReminder,
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.sendComprehensiveSlinePaymentReminder()
      }
    }
  }, [(!_vm.isSendingReminder) ? _c('i', {
    staticClass: "fa fa-paper-plane mr-1"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.slineReminderBtnName) + "\n            "), (_vm.isSendingReminder) ? _c('b-spinner', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": _vm.Filter.activeButtonFilter ? 'outline-danger' : 'outline-primary',
      "aria-expanded": _vm.Filtervisible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.Filtervisible = !_vm.Filtervisible;
        _vm.clearBranchBtnFilter();
      }
    }
  }, [_vm._v(_vm._s(_vm.Filtervisible ? "Filter ON" : "Filter OFF"))])], 1), _vm._v(" "), (_vm.Filtervisible) ? _c('b-col', {
    staticClass: "ml-4",
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "pressed": _vm.activeButtonBranch,
      "variant": _vm.activeButtonBranch ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter('Branch')
      }
    },
    model: {
      value: (_vm.Filter.activeButtonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeButtonFilter", $$v)
      },
      expression: "Filter.activeButtonFilter"
    }
  }, [_vm._v("Branch " + _vm._s(_vm.activeButtonBranch ? " Filter On" : " Filter Off"))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "pressed": _vm.activeButtonClient,
      "variant": _vm.activeButtonClient ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter('Client')
      }
    },
    model: {
      value: (_vm.Filter.activeButtonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeButtonFilter", $$v)
      },
      expression: "Filter.activeButtonFilter"
    }
  }, [_vm._v("Client " + _vm._s(_vm.activeButtonClient ? " Filter On" : " Filter Off"))])], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.activeButtonFilter) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.BranchInvStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Inv/BL Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.activeTallyBLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeTallyBLFilter", $$v)
      },
      expression: "Filter.activeTallyBLFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "11"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Months/Year")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingFilter),
      callback: function($$v) {
        _vm.billingFilter = $$v
      },
      expression: "billingFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Sob Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Prealert Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PrealertStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Prealert Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.PrealertFilter),
      callback: function($$v) {
        _vm.PrealertFilter = $$v
      },
      expression: "PrealertFilter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('h5', {
    staticClass: "text-muted mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + "Entries")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.FFExport,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))]), _vm._v(" "), (row0.item.rollover_event_code == 1) ? _c('span', {
          class: {
            alert: true,
              'alert-danger-text': row0.item.rollover_event_code == 1,
              blink: row0.item.rollover_event_code == 1,
          }
        }, [_c('br'), _vm._v("This Event is Rollover")]) : _vm._e()]
      }
    }, {
      key: "ffExportFclSeries",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "text-left",
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black')
        }, [_c('div', {
          staticClass: "showMoreData",
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black'),
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewExportFCLPage(row11.item)
            }
          }
        }, [(row11.item.seenExec == '0') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("New\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(row11.item.ffExportFclSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row11.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row11.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row11.item.raisedBy)), _c('br')]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row11.item.is_locked == '1' &&
              (row11.item.finalBillingCompleted == 1 ||
                row11.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) ?
                _vm.LockUnLock(row11.item, 'locked') :
                ''
            }
          }
        }, [(
          row11.item.is_locked == '1' &&
          (row11.item.finalBillingCompleted == 1 ||
            row11.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), _c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), ((row11.item.finalBillingCompleted == '1')) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing\n                    Completed")]) : (row11.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed -\n                    Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _c('br'), _vm._v(" "), (row11.item.is_prealertSend == '1') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Prealert Send : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("YES")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (row11.item.is_prealertSend == '0') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Prealert Send : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("NO")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (
          row11.item.sob_date_detected != '' &&
          row11.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row11.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e(), _vm._v(" "), (
          row11.item.SplitMergeCount != '' && row11.item.SplitMergeCount != 0
        ) ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v("Split Merge Activated")])]) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row11.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), (
          row11.item.toSplitAssignmentNo && row11.item.newContainerFlow == '1'
        ) ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row11.item.toSplitAssignmentNo))])], 1) : _vm._e()], 1), _vm._v(" "), (row11.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row11.item.ffExportFclSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row11.item.allModuleId,
            "jb_series": row11.item.ffExportFclSeries
          }
        }), _vm._v(" "), (row11.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row11.item.ffExportFclSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row11.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row11.item.allModuleId),
            "JobNo": row11.item.ffExportFclSeries
          }
        }) : _vm._e(), _vm._v(" "), (row11.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row11.item.ffExportFclSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row11.item,
            "JobNo": row11.item.ffExportFclSeries,
            "JobID": row11.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row11.item.deleteRequestBy != '' && row11.item.deleteRequestBy != '0' && row11.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested\n                By : " + _vm._s(row11.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.deleteArrovedBy != '' && row11.item.deleteArrovedBy != '0' && row11.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved\n                By : " + _vm._s(row11.item.deleteArrovedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.allModuleId) ? _c('WebhookLogSummary', {
          attrs: {
            "show-trigger-button": true,
            "PMC_title": 'Webhook Log',
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row11.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary',
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row2) {
        return [_c('div', {
          staticClass: "status-alerts"
        }, [_c('span', {
          class: {
            alert: true,
              'alert-danger-text': row2.item.sub_noti_risk_verbose == 'High risk',
              blink: row2.item.sub_noti_risk_verbose == 'High risk',
          }
        }, [(
          row2.item.sub_noti_event_message != '' &&
          row2.item.sub_noti_event_message != null
        ) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_c('b', [_vm._v("Event MSG : " + _vm._s(row2.item.sub_noti_event_message))])]) : _vm._e(), _c('br'), _vm._v(" "), (
          row2.item.status_verbose != '' && row2.item.status_verbose != null
        ) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_c('b', [_vm._v("Status Verbose : " + _vm._s(row2.item.status_verbose))])]) : _vm._e(), _c('br'), _vm._v(" "), (
          row2.item.sub_noti_risk != '' && row2.item.sub_noti_risk != null
        ) ? _c('span', [_c('b', [_vm._v("Status : " + _vm._s(row2.item.sub_noti_risk_verbose))]), _c('br')]) : _vm._e(), _vm._v(" "), (
          row2.item.sub_noti_risk != '' && row2.item.sub_noti_risk != null
        ) ? _c('span', [_c('b', [_vm._v("Desc : " + _vm._s(row2.item.sub_noti_risk_description))]), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row2.item.clientName))])]
      }
    }, {
      key: "newfreightContainers",
      fn: function(row5) {
        return [_c('BookingTrack', {
          attrs: {
            "containerArr": row5.item.newfreightContainers,
            "slineName": row5.item.slineName,
            "clientName": row5.item.clientName,
            "modal_title": ("Container Movement Booking No: " + (row5.item.validBookingNo) + " Job No - " + (row5.item.ffExportFclSeries) + " Client: " + (row5.item.clientName)),
            "JOBNO": row5.item.ffExportFclSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row5.item.allModuleId),
            "fk_booking_id": Number(row5.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row5.item.validBookingNo,
            "container_number": ''
          }
        }), _vm._v(" "), (row5.item.newContainerFlow == '1') ? _c('div', [(row5.item.newfreightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.newfreightContainers) ? _c('div', _vm._l((row5.item.newfreightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")]), _vm._v(" "), (row5.item.allModuleId && item1) ? _c('ContaierWebLogSummary', {
            attrs: {
              "PMC_title": 'Container Event Summary Job No - ' + row5.item.ffExportFclSeries,
              "PMC_JOBID": row5.item.allModuleId,
              "PMC_JOBNO": row5.item.ffExportFclSeries,
              "PMC_CONTNO": item1,
              "PMC_JOBDATE": '',
              "PMC_JOBTYPE": '',
              "PMC_AgentType": '',
              "PMC_Client": '',
              "PMC_Sline": ''
            }
          }) : _vm._e()], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row5.item.newContainerFlow == '0') ? _c('div', [(row5.item.freightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.freightContainers) ? _c('div', _vm._l((row5.item.freightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "newShipperInv",
      fn: function(row56) {
        return [(row56.item.newContainerFlow == '1') ? _c('div', [(row56.item.newShipperInv) ? _c('div', {
          staticClass: "text-left"
        }, [(row56.item.newShipperInv) ? _c('div', _vm._l((row56.item.newShipperInv.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row56.item.newContainerFlow == '0') ? _c('div', [(row56.item.shipperInvNo) ? _c('div', {
          staticClass: "text-left"
        }, [(row56.item.shipperInvNo) ? _c('div', _vm._l((row56.item.shipperInvNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "newSB",
      fn: function(row564) {
        return [(row564.item.newContainerFlow == '1') ? _c('div', [(row564.item.newSB) ? _c('div', {
          staticClass: "text-left"
        }, [(row564.item.newSB) ? _c('div', _vm._l((row564.item.newSB.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row564.item.newContainerFlow == '0') ? _c('div', [(row564.item.shippingBillNo) ? _c('div', {
          staticClass: "text-left"
        }, [(row564.item.shippingBillNo) ? _c('div', _vm._l((row564.item.shippingBillNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "POR",
      fn: function(row10) {
        return [_c('span', [_vm._v("Stuffing :-\n                " + _vm._s(row10.item.stuffingType == "warehouseStuffing" ?
          "WAREHOUSE" :
          "FACTORY")), _c('br')]), _vm._v(" "), _c('span', [_vm._v("S-Line :- " + _vm._s(row10.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR :- " + _vm._s(row10.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("LP :- " + _vm._s(row10.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD :- " + _vm._s(row10.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD :- " + _vm._s(row10.item.FPOD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          style: (row10.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row10.item.SubscriptionId ? _vm.goToSubscriptionPage(row10.item) : ''
            }
          }
        }, [_vm._v("Booking No. :- " + _vm._s(row10.item.validBookingNo))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "invoiceStatus",
      fn: function(row33) {
        return [(row33.item.isfinalsalesBillingComplete != 0) ? _c('b', {
          style: (row33.item.isfinalsalesBillingComplete == '1' ?
            {
              color: 'green'
            } :
            {
              color: 'red'
            })
        }, [_vm._v(_vm._s(row33.item.isfinalsalesBillingComplete == 1 ? "Not To Be Billed" : "--"))]) : _c('b', {
          style: (row33.item.invoiceStatus == '0' ? {
            color: 'green'
          } : {
            color: 'red'
          })
        }, [_vm._v(_vm._s(!row33.item.invoiceStatus ?
          "--" :
          row33.item.invoiceStatus == "1" ?
          "In-Progress" :
          row33.item.invoiceStatus == "0" ?
          "Sent To Accounts" :
          "--"))]), _vm._v(" "), (row33.item.sentForApproval && row33.item.sentForApproval == '1') ? _c('b', [_c('br'), _vm._v("\n                Sent for Approval\n              ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '1'
        ) ? _c('b', [_c('br'), _vm._v("\n                Was Sent for Approval and got Approved\n              ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '2'
        ) ? _c('b', [_c('br'), _vm._v("\n                Was Sent for Approval and got Rejected\n              ")]) : _vm._e()]
      }
    }, {
      key: "eta_details",
      fn: function(row321) {
        return [(row321.item.ETA_destination_estimated != '') ? _c('span', [_vm._v("Tentative : " + _vm._s(row321.item.ETA_destination_estimated))]) : _vm._e(), _vm._v(" "), (row321.item.ETA_destination_actual != '') ? _c('span', [_c('br'), _vm._v("Actual : " + _vm._s(row321.item.ETA_destination_actual))]) : _vm._e()]
      }
    }, {
      key: "show_details",
      fn: function(row4) {
        return [(row4.item.status_verbose != '' && row4.item.status_verbose != null) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_c('b', {
          style: ('color:black')
        }, [_vm._v("Status Verbose : " + _vm._s(row4.item.status_verbose))])]) : _vm._e(), _vm._v(" "), (row4.item.newContainerFlow == '0') ? _c('b-form-checkbox', {
          on: {
            "change": row4.toggleDetails
          },
          model: {
            value: (row4.detailsShowing),
            callback: function($$v) {
              _vm.$set(row4, "detailsShowing", $$v)
            },
            expression: "row4.detailsShowing"
          }
        }) : _vm._e(), _vm._v(" "), (row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Status : " + _vm._s(row4.item.sub_noti_risk_verbose))]), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Desc : " + _vm._s(row4.item.sub_noti_risk_description))]), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Conclusion : " + _vm._s(row4.item.sub_noti_conclusion))])]) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row4.item.allModuleId,
            "fk_client_id": row4.item.clientId,
            "fk_pod_id": row4.item.PODLocationId
          }
        }), _vm._v(" "), (
          row4.item.is_locked == '1' &&
          row4.item.is_prealertSend == '1' &&
          row4.item.manifestcount <= 0
        ) ? _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.sendMANIFESTATION(row4.item)
            }
          }
        }, [_vm._v("SEND\n                MANIFESTATION")]) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [(_vm.freight == true) ? _c('div', {
          staticClass: "col-md-4"
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.goToDoc(row4.item.ffExportFclId)
            }
          }
        }, [_vm._v("View\n                    Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.showSMModal(row4.item, 'S')
            }
          }
        }, [_vm._v("Split\n                    Assignment")]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.showSMModal(row4.item, 'M')
            }
          }
        }, [_vm._v("Merge\n                    Assignment")]), _vm._v(" "), _c('label', [_vm._v("Assignment Split / Merge Details")]), _vm._v(" "), (
          row4.item.toSplitAssignmentNo != null &&
          row4.item.toSplitAssignmentNo != ''
        ) ? _c('div', [_c('b', [_vm._v("Split Details:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Splited To Assignment No.:\n                      " + _vm._s(row4.item.toSplitAssignmentNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Container Type: " + _vm._s(row4.item.splitContainer))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("No. of Containers: " + _vm._s(row4.item.splitContainerCount))])]) : _c('div', [_c('b', [_vm._v("Split Details:NA")])]), _vm._v(" "), (
          row4.item.toMergeAssignmentNo != null &&
          row4.item.toMergeAssignmentNo != ''
        ) ? _c('div', [_c('b', [_vm._v("Merge Details:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Merged In Assignment No.: " + _vm._s(row4.item.toMergeAssignmentNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Container Type: " + _vm._s(row4.item.mergeContainer))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("No. of Containers: " + _vm._s(row4.item.mergeContainerCount))])]) : _c('div', [_c('b', [_vm._v("Merge Details:NA")])])], 1) : _vm._e(), _vm._v(" "), (_vm.freight == true) ? _c('div', {
          staticClass: "col-md-4"
        }, [_c('label', [_vm._v("Documentation Progress")]), _vm._v(" "), (row4.item.stuffingType != 'warehouseStuffing') ? _c('div', [_c('b', [_vm._v("VGM Submission Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.vgmSubmissionDate != null ? 'Completed' : 'color:red')
        }, [_vm._v(_vm._s(row4.item.vgmSubmissionDate != null ? "Completed" : "Pending"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Gate-In Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.gateInDate != null ?
            'Completed' :
            row4.item.vgmSubmissionDate != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.gateInDate != null ?
          "Completed" :
          row4.item.vgmSubmissionDate != null ?
          "Pending" :
          "--"))]), _vm._v(" "), _c('br'), _vm._v(" "), (
          row4.item.portType == 'Icd' &&
          (row4.item.stuffingType == 'factoryStuffing' ||
            row4.item.stuffingType == 'warehouseStuffing')
        ) ? _c('b', [_vm._v("Handover:")]) : _vm._e(), _vm._v(" "), (
          row4.item.portType == 'Icd' &&
          (row4.item.stuffingType == 'warehouseStuffing' ||
            row4.item.stuffingType == 'factoryStuffing')
        ) ? _c('span', {
          style: (row4.item.handoverToRailId != null ?
            'Completed' :
            row4.item.gateInDate != null ?
            'color:red' :
            '--')
        }, [_vm._v(_vm._s(row4.item.handoverToRailId != null ?
          "Completed" :
          row4.item.gateInDate != null ?
          "Pending" :
          "--"))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
          row4.item.portType == 'Icd' &&
          (row4.item.stuffingType == 'factoryStuffing' ||
            row4.item.stuffingType == 'warehouseStuffing')
        ) ? _c('b', [_vm._v("Rail Out :")]) : _vm._e(), _vm._v(" "), (
          row4.item.portType == 'Icd' &&
          (row4.item.stuffingType == 'warehouseStuffing' ||
            row4.item.stuffingType == 'factoryStuffing')
        ) ? _c('span', {
          style: (row4.item.ffRailOutId != null ?
            'Completed' :
            row4.item.handoverToRailId != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.ffRailOutId != null ?
          "Completed" :
          row4.item.handoverToRailId != null ?
          "Pending" :
          "--"))]) : _vm._e()]) : _c('div', [_c('b', [_vm._v("VGM Submission Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.wareVgmSub != null ? 'Completed' : 'color:red')
        }, [_vm._v(_vm._s(row4.item.wareVgmSub !=
          null ? "Completed" : "Pending"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Gate-In Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.wareGate != null ?
            'Completed' :
            row4.item.wareVgmSub != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.wareGate != null ?
          "Completed" :
          row4.item.wareVgmSub != null ?
          "Pending" :
          "--"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Handover:")]), _vm._v(" "), _c('span', {
          style: (row4.item.handoverToRailId != null ?
            'Completed' :
            row4.item.wareGate != null ?
            'color:red' :
            '--')
        }, [_vm._v(_vm._s(row4.item.handoverToRailId != null ?
          "Completed" :
          row4.item.wareGate != null ?
          "Pending" :
          "--"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Rail Out :")]), _vm._v(" "), _c('span', {
          style: (row4.item.ffRailOutId != null ?
            'Completed' :
            row4.item.handoverToRailId != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.ffRailOutId != null ?
          "Completed" :
          row4.item.handoverToRailId != null ?
          "Pending" :
          "--"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Sail Out :")]), _vm._v(" "), _c('span', {
          style: (row4.item.ffSailId != null ?
            'Completed' :
            row4.item.ffRailOutId != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.ffSailId != null ?
          "Completed" :
          row4.item.ffRailOutId != null ?
          "Pending" :
          "--"))])])]) : _vm._e(), _vm._v(" "), (_vm.freight == true) ? _c('div', {
          staticClass: "col-md-4"
        }, [_c('label', [_vm._v("Customer Service")]), _vm._v(" "), (row4.item.stuffingType != 'warehouseStuffing') ? _c('div', [_c('b', [_vm._v("SI Submission Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.siSubmissionDate != null ? 'Completed' : 'color:red')
        }, [_vm._v(_vm._s(row4.item.siSubmissionDate != null ? "Completed" : "Pending"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("B/L Original Print :")]), _vm._v(" "), _c('span', {
          style: (row4.item.fclBlId != null ?
            'Completed' :
            row4.item.siSubmissionDate != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.fclBlId != null ?
          "Completed" :
          row4.item.siSubmissionDate != null ?
          "Pending" :
          "--"))])]) : _c('div', [_c('b', [_vm._v("SI Submission Date :")]), _vm._v(" "), _c('span', {
          style: (row4.item.wareSi != null ? 'Completed' : 'color:red')
        }, [_vm._v(_vm._s(row4.item.wareSi != null ? "Completed" : "Pending"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("B/L Original Print :")]), _vm._v(" "), _c('span', {
          style: (row4.item.fclBlId != null ?
            'Completed' :
            row4.item.wareSi != null ?
            'color:red' :
            '')
        }, [_vm._v(_vm._s(row4.item.fclBlId != null ?
          "Completed" :
          row4.item.wareSi != null ?
          "Pending" :
          "--"))])])]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirmModal",
    attrs: {
      "id": "modal-multi-3",
      "hide-footer": "",
      "title": "Confirmation"
    }
  }, [_c('p', {
    staticClass: "my-1"
  }, [_vm._v("\n        " + _vm._s(_vm.mergeModal.actionType == "2" ?
    "Are you sure you want to Split this Assignment..!" :
    "Are you sure you want to Merge containers of this Assignment to selected Assignment..!") + "\n      ")]), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogConfirm
    }
  }, [_vm._v("Cancel & Close")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.isLoading == true ? true : false,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.onCloseSubmit
    }
  }, [_vm._v("Yes")])], 1)]), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "splitMergePop",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "scrollable": "",
      "id": "myDIV",
      "hide-footer": "",
      "title": _vm.mergeModal.actionType == '2' ?
        'Assignment Split Utility' :
        'Assignment Merge Utility'
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Action")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.actionList,
      "id": "actionType",
      "option-value": "aV",
      "option-text": "aT",
      "placeholder": "Select Action "
    },
    on: {
      "input": _vm.getSplitAssignment
    },
    model: {
      value: (_vm.mergeModal.actionType),
      callback: function($$v) {
        _vm.$set(_vm.mergeModal, "actionType", $$v)
      },
      expression: "mergeModal.actionType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.mergeModal.actionType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mergeModal.actionType == '1' ?
        _vm.toMergeAssignmentList :
        _vm.dummySplitAssignment,
      "id": "clientId",
      "option-value": "ffExportFclId",
      "option-text": "ffExportFclSeries",
      "placeholder": "Select Assignment "
    },
    on: {
      "input": _vm.getTomergeExecId
    },
    model: {
      value: (_vm.mergeModal.ffExportFclIdContainer),
      callback: function($$v) {
        _vm.$set(_vm.mergeModal, "ffExportFclIdContainer", $$v)
      },
      expression: "mergeModal.ffExportFclIdContainer"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.mergeModal.actionType == '1') ? _c('div', {
    staticClass: "gutr",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter1),
      callback: function($$v) {
        _vm.filter1 = $$v
      },
      expression: "filter1"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter1
    },
    on: {
      "click": function($event) {
        _vm.filter1 = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "",
      "bordered": "",
      "show-empty": "",
      "stacked": "md",
      "items": _vm.toMergeAssignmentList,
      "fields": _vm.fields1,
      "current-page": _vm.currentPage1,
      "per-page": _vm.perPage1,
      "filter": _vm.filter1,
      "sort-by": _vm.sortBy1,
      "sort-desc": _vm.sortDesc1,
      "sort-direction": _vm.sortDirection1
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy1 = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc1 = $event
      },
      "filtered": _vm.onFiltered1
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage1 - 1) * _vm.perPage1))])]
      }
    }, {
      key: "loginTime",
      fn: function(row1) {
        return [_c('b-form-radio', {
          attrs: {
            "disabled": _vm.containerList.length > 0 ? true : false,
            "name": "some-radios",
            "value": row1.item.ffExportFclId
          },
          on: {
            "change": function($event) {
              _vm.onRadioMerge(row1.item.ffExportFclId)
            }
          },
          model: {
            value: (_vm.mergeModal.ffExportFclIdContainer),
            callback: function($$v) {
              _vm.$set(_vm.mergeModal, "ffExportFclIdContainer", $$v)
            },
            expression: "mergeModal.ffExportFclIdContainer"
          }
        }, [_vm._v("Select")])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows1,
      "per-page": _vm.perPage1
    },
    model: {
      value: (_vm.currentPage1),
      callback: function($$v) {
        _vm.currentPage1 = $$v
      },
      expression: "currentPage1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.FFExportContainers.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "po"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Net Weight")]), _vm._v(" "), _c('th', [_vm._v("Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Select")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FFExportContainers), function(item1, index) {
    return _c('tr', {
      key: index,
      style: (item1.seenExec == '0' ? 'color:red' : 'color:black')
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Container No. :")]), _vm._v(" "), _c('span', {
      staticClass: "mainClick"
    }, [_vm._v(_vm._s(item1.containerNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Container Type :")]), _vm._v(" "), _c('span', {
      staticClass: "mainClick"
    }, [_vm._v(_vm._s(item1.containerType))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.netWeight) + _vm._s(item1.weightUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.grossWeight) + _vm._s(item1.weightUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.LineSealNo))]), _vm._v(" "), _c('td', [_c('md-checkbox', {
      staticClass: "md-primary",
      class: _vm.mergeFclContainers.indexOf(item1.ffExportFclId) >= 0 ?
        'md-checked checkedNew' +
        item1.ffExportFclId +
        (index + 1) :
        'checkedNew' + item1.ffExportFclId + (index + 1),
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "disabled": _vm.mergeModal.actionType == '1' &&
          _vm.mergeModal.ffExportFclIdContainer == '' ?
          true :
          false,
        "md-value": item1.ffExportFclId,
        "name": 'deptMas' + (item1.ffExportFclId + 1),
        "id": 'deptMas' + (item1.ffExportFclId + 1)
      },
      on: {
        "change": function($event) {
          _vm.getMergeContainerData(item1, index)
        }
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "pull-right ml-2",
    attrs: {
      "disabled": _vm.containerList.length <= 0 ||
        (_vm.FFExportContainers.length <= 1 && _vm.mergeModal.actionType == '2'),
      "variant": "primary"
    },
    on: {
      "click": _vm.mergeSubmit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeMerge
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e()], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopSubmit",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseSubmit
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63fdba9d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ViewffExportFcl.vue
// module id = 2684
// module chunks = 0